<template>
    <el-container>
        <el-header style="height: 100px;">
            <el-form :inline="true" :model="fromAlarmEvent" ref="fromAlarmEvent" class="demo-form-inline" @submit.native.prevent>
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :permissions="permissionsQuery">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.ALARM_SERIAL_NUMBER')" prop="sId">
                                    <td-input v-model="fromAlarmEvent.sId"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('common.NAME')" prop="sName">
                                    <td-input v-model="fromAlarmEvent.sName"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('common.ALARM_SOURCE')" prop="iAlarmSourceType">
                                    <td-select v-model="fromAlarmEvent.IAlarmSourceType"  :options="alarmSourceList" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
                                </el-form-item>
                                <el-form-item :label="$t('common.ALARM_LEVEL')" prop="sAlarmLevelId">
                                    <td-select v-model="fromAlarmEvent.sAlarmLevelId" keys="sId" text="sName" :options="alarmLevelList" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
                                </el-form-item>
                                <el-form-item :label="$t('pgCommon.ALARM_GROUP')" prop="sAlarmTypeId">
                                    <td-tree-select
                                        ref="TdTree"
                                        :treeList="treeList"
                                        :lazyloading="lazyloading"
                                        :defaultProps="defaultProps"
                                        :isSingleCheck="isSingleCheck"
                                        :inputShow="inputShow"
                                        :nodeKey="nodeKey"
                                        :expandAll="expandAll"
                                        :multiple="true"
                                        :refreshIconShowSel="false"
                                    ></td-tree-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnClickQuery">{{
                                $t('common.QUERY')
                            }}</td-button>
                            <td-button type="button" :permissions="permissionsEdit" @click="btnClassification">{{ $t('pgCommon.GROUP') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click="btnAddEvent">{{ $t('common.ADD') }}</td-button>
                            <td-button type="button" :permissions="permissionsDelete" @click="btnDeleteEvent">{{ $t('common.DELETE_BATCH') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                ref="tableInfo"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :rowKey="rowKey"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-eventInfo
                v-if="dialogEventVisible"
                :isAddData="isAddData"
                :dialogEventVisible="dialogEventVisible"
                :sIdDisabled="sIdDisabled"
                :editItem="editItem"
                :title="title"
                @eventDialogClose="eventDialogClose"
                @submit="submit"
            ></dialog-eventInfo>
            <dialog-classification
                v-if="dialogClassifyVisible"
                :dialogClassifyVisible="dialogClassifyVisible"
                :editItem="editItem"
                :title="title"
                @classifyDialogClose="classifyDialogClose"
            ></dialog-classification>
        </el-main>
    </el-container>
</template>

<script>
import api from './assets/api.js';
import dialogEventInfo from './components/dialogEventInfo.vue';
import dialogClassification from './components/dialogClassification.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-eventInfo': dialogEventInfo,
        'dialog-classification': dialogClassification
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryAlarmTypeTreeFlag = true;
        this.initSelect();
    },
    activated() {
         if (!this.queryAlarmTypeTreeFlag) {
            this.initSelect();
        }
        this.queryAlarmTypeTreeFlag = false;
    },
    // 定义数据
    data() {
        return {
            fromAlarmEvent: { sName: '', sId: '' },
            permissionsQuery: ['alarmEvent:view'],
            permissionsAdd: ['alarmEvent:add'],
            permissionsDelete: ['alarmEvent:del'],
            permissionsEdit: ['alarmEvent:edit'],
            alarmSourceList:window.pangu.common.alarmSourceList,
            alarmLevelList: [],
            dialogEventVisible: false,
            dialogClassifyVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            defaultProps: {
                children: 'children',
                label: 'typeName',
                id: 'id',
                parentId: 'parentId'
            },
            lazyloading: false,
            treeList: [],
            isSingleCheck: false,
            inputShow: false,
            expandAll: true,
            queryAlarmTypeTreeFlag: false,
            nodeKey: 'id',
            rowKey: 'sId',
            columns: [
                {
                    prop: 'sId',
                    label: this.$t('common.ALARM_SERIAL_NUMBER'),
                    tableWidth: '150'
                },
                {
                    prop: 'sName',
                    label: this.$t('common.NAME')
                },
                {
                    prop: 'iAlarmSourceType',
                    label: this.$t('common.ALARM_SOURCE'),
                    align: 'center',
                    render: (createElement, params) => {
                        var alarmSourceTypeLabel = params.row.iAlarmSourceType== window.pangu.common.alarmSource.device?this.$t('common.ALARM_SOUECE_DEVICE'):this.$t('common.ALARM_SOUECE_GENERAL');
                        return createElement('span',alarmSourceTypeLabel);
                    }
                },
                {
                    prop: 'sAlarmLevelName',
                    label: this.$t('common.ALARM_LEVEL'),
                    tableWidth: '250'
                },
                {
                    prop: 'sAlarmTypeName',
                    label: this.$t('pgCommon.ALARM_GROUP'),
                    tableWidth: '250'
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmEvent:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmEvent:del'] },
                                    on: {
                                        click: () => {
                                            this.btnDelete([params.row.sId]);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        initSelect() {
            api.getAlarmLevel('{}', response => {
                this.alarmLevelList = response.data.content;
            });
            api.getAlarmTypeTree('', response => {
                this.treeList = response.data.content;
            });
        },
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        //查询点击按钮
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let alarmTypeNode = this.$refs.TdTree.getSelectedNodes();
            let alarmTypeIdList = [];
            if (alarmTypeNode) {
                alarmTypeNode.forEach(element => {
                    alarmTypeIdList.push(element.id);
                });
            }
            let param = {
                sName: this.fromAlarmEvent.sName,
                sId: this.fromAlarmEvent.sId,
                IAlarmSourceType:this.fromAlarmEvent.IAlarmSourceType,
                sAlarmLevelId: this.fromAlarmEvent.sAlarmLevelId,
                alarmTypeIdList: alarmTypeIdList,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            api.getAlarmEvent(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getAlarmEvent', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                if(null != response.data.content && "" != response.data.content && response.data.content.length > 0){
                    for(let i=0;i<response.data.content.length;i++){
                        if(response.data.content[i].iAlarmSourceType == 1){
                            response.data.content[i].sAlarmLevelName = "";
                        }
                    }
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddEvent() {
            this.title = this.$t('common.ADD');
            this.isAddData = true;
            this.dialogEventVisible = true;
            this.sIdDisabled = false;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogEventVisible = true;
            this.sIdDisabled = true;
        },
        // 获取选中表格数据的id
        getTableSelectId() {
            let selectData = this.$refs.tableInfo.getSelectAllRows();
            let tableId = [];
            for (let i = 0; i < selectData.length; i++) {
                tableId.push(selectData[i].sId);
            }
            return tableId;
        },
        // 批量删除
        btnDeleteEvent() {
            let tableId = this.getTableSelectId();
            if (tableId.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.btnDelete(tableId);
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.deleteAlarmEvent(JSON.stringify(sId), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/deleteAlarmEvent', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 分类
        btnClassification() {
            this.title = this.$t('pgCommon.ALARM_GROUP');
            this.dialogClassifyVisible = true;
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        eventDialogClose() {
            this.dialogEventVisible = false;
        },
        // 关闭分类页面
        classifyDialogClose() {
            this.submit();
            this.dialogClassifyVisible = false;
        }
    }
};
</script>
